import React from 'react';
import { Link } from 'react-router-dom';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';

export class QuickViewNotAvailable extends React.Component {
  render() {
    return (
      <section id='QuickViewDisplay' aria-hidden='false'>
        <div className='row'>
          <div className='col-sm-12'>
            <button
              type='button'
              className='close notAvailable--close btn-tertiary'
              onClick={this.props.passedAppFunctions.closeQuickView}
            >
              <CloseXIcon />
            </button>
            <div id='error-message' className='alert alert-danger notAvailable--message' role='alert'>
              This item is not available for internet purchase.
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default QuickViewNotAvailable;
